import React from 'react';
import { EditButton, useRecordContext, TopToolbar } from 'react-admin';
import { Button, Menu, MenuItem } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import config from 'config';
import { ENUMS } from 'components/Enum/enums';
import ApprovalButton from './ApprovalButton';
import AvailableProfessionalsSearch from 'components/AvailableProfessionalsSearch';
import { CreateTestJobButton } from './CreateTestJobButton';
import useGate from 'hooks/useGate';
import { gateNames } from 'constants/statsig';
import { useMenu } from 'hooks/useMenu';
import useClipboard from 'hooks/useClipboard';
import useNotifyWrap from 'hooks/useNotifyWrap';

const JobCopyLink = () => {
  const record = useRecordContext();
  const { triggerProps, menuProps } = useMenu();
  const copy = useNotifyWrap(useClipboard(), {
    onSuccess: 'Copied',
  });

  if (![ENUMS.Job.status.active].includes(record?.status)) {
    return null;
  }

  return (
    <>
      <Button
        size="small"
        {...triggerProps}
        variant="outlined"
        color="primary"
        endIcon={<ExpandMore />}
      >
        Copy link
      </Button>
      <Menu {...menuProps}>
        <MenuItem
          onClick={() =>
            copy(`${config.client_url.professional}/available/jobs?override_redirect=true`)
          }
        >
          Available jobs
        </MenuItem>
        <MenuItem
          onClick={() =>
            copy(
              `${config.client_url.professional}/available/jobs/${record.id}?override_redirect=true`,
            )
          }
        >
          Job
        </MenuItem>
      </Menu>
    </>
  );
};

const JobShowActions = () => {
  const record = useRecordContext();
  const { value: blockPostShifts } = useGate(gateNames.blockPostShifts);
  const showApprovalButton = record?.status === 'held_for_dispute_review';

  return (
    <TopToolbar>
      <JobCopyLink />
      {!config.is_production && [ENUMS.Job.status.active].includes(record?.status) && (
        <AvailableProfessionalsSearch />
      )}
      <CreateTestJobButton />
      {blockPostShifts ? null : showApprovalButton ? (
        <ApprovalButton />
      ) : (
        <EditButton data-testid="edit-button" />
      )}
    </TopToolbar>
  );
};

export default JobShowActions;
